import script from "./LoyaltyProgramSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./LoyaltyProgramSettings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import ExplanationBox from "@/components/ExplanationBox.vue";
import InputArea from "@/components/neue/InputArea.vue";
import InputField from "@/components/neue/InputField.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeueWell from "@/components/neue/NeueWell.vue";
import SaveBar from "@/components/SaveBar.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
import SecondaryTop from "@/components/SecondaryTop.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { ExplanationBox, InputArea, InputField, NeueButton, NeueLoading, NeueWell, SaveBar, SecondaryNav, SecondaryTop, SelectInput, SettingsSection, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ExplanationBox, InputArea, InputField, NeueButton, NeueLoading, NeueWell, SaveBar, SecondaryNav, SecondaryTop, SelectInput, SettingsSection, TheModal }, script.__o.components);}